import React, { useEffect } from 'react';
import { numToPrice } from '../utils';
import PlayerCard from './PlayerCard';
import { normalizeCardPlayer } from './cardUtils';

function TransferRevealModal({
  notification,
  teamName,
  counter,
  onClose,
  onViewSquad,
}) {
  const card = notification?.data?.card || {};
  const player = normalizeCardPlayer(card);
  const rawAmount = notification?.data?.winningBid ?? notification?.data?.amount;
  const numericAmount = Number(rawAmount);
  const formattedAmount = Number.isFinite(numericAmount) ? numToPrice(numericAmount) : 'amount unavailable';

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  const handleBackdropMouseDown = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="transfer-reveal" onMouseDown={handleBackdropMouseDown}>
      <section
        className="transfer-reveal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="transfer-reveal-title"
      >
        <button
          type="button"
          className="transfer-reveal__close"
          onClick={onClose}
          aria-label="Close transfer reveal"
        >
          Close
        </button>
        {counter ? <p className="transfer-reveal__counter">{counter}</p> : null}
        <h2 id="transfer-reveal-title">DEAL DONE</h2>
        <p className="transfer-reveal__subheading">OFFICIAL SIGNING</p>
        <div className="transfer-reveal__card-wrap">
          <PlayerCard player={card} size="lg" className="transfer-reveal__card" />
        </div>
        <p className="transfer-reveal__deal-line">
          <b>{player.name || 'Your new player'}</b> joins <b>{teamName || 'your team'}</b> for <b>{formattedAmount}</b>
        </p>
        <div className="transfer-reveal__actions">
          <button type="button" className="transfer-reveal__button" onClick={onViewSquad}>
            VIEW SQUAD
          </button>
          <button type="button" className="transfer-reveal__button transfer-reveal__button--secondary" onClick={onClose}>
            DONE
          </button>
        </div>
      </section>
    </div>
  );
}

export default TransferRevealModal;
